






































import { Mixins, Component } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../../../components/system";
import { IEditableFormatSummaryTreeNode } from "../../../../../../domain/editableFormat";
import { Directory } from "../../../../../../../../domain/drawing";
import { FormatTreeSourceSelectableMixin } from "../../../../selectors/trees/mixins";
import EditableFormatSummariesTreeSelector from "../../../../selectors/trees/EditableFormatSummariesTreeSelector.vue";

@Component({
  components: {
    selector: EditableFormatSummariesTreeSelector,
  }
})
export default class EditableFormatSummaryTreeSelectDialog extends Mixins(DialogMixin, FormatTreeSourceSelectableMixin) {
  data() {
    return {
      isSearching: false,
      selectedDirectoryId: null as number,
      confirmSelected: false,
    };
  }
  isSearching: boolean;
  selectedDirectoryId: number;
  confirmSelected: boolean;

  get isSelected(): boolean {
    return !!this.selectedDirectoryId;
  }

  async show(): Promise<number> {
    return this.showModal(async () => {
      this.confirmSelected = false;
      this.isSearching = true;
      await this.loadTree();
      this.isSearching = false;
      await this.waitHidden();
      return this.confirmSelected ? this.selectedDirectoryId : null;
    });
  }

  treeNodeSelected(value: IEditableFormatSummaryTreeNode): void {
    this.selectedDirectoryId = (!!value && (value.data.source instanceof Directory)) ? value.data.source.key : null;
  }

  confirmSelect(): void {
    this.confirmSelected = true;
    this.isVisible = false;
  }

  cancelSelect(): void {
    this.isVisible = false;
  }
}
